import { BankAccountTimelineEvent } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/BankAccounts/BankAccountDetails/components/bankAccountTimeline.types.ts';
import {
	AuditTableDataContext,
	transformAuditToTableData,
} from '@dealstack/frontend/shared/components/Audit/AuditLayout/auditTableData.utils.ts';
import { toEntryRows } from '@dealstack/frontend/shared/components/Audit/AuditLayout/auditWrites.utils.ts';
import { TransformedAuditData } from '@dealstack/frontend/shared/components/Audit/types.ts';
import { AuditAction } from '@dealstack/shared/lib/generated';

/**
 * What one timeline event changed, as before/after rows. The view renders one column set
 * for every event, so a create or delete is read out on a side rather than on its own.
 */
export const toBankAccountEventDiff = (
	event: BankAccountTimelineEvent,
	context: AuditTableDataContext
): TransformedAuditData[] =>
	toEntryRows(event, (audit) => transformAuditToTableData(audit, context), AuditAction.UPDATE);
